import { Injectable } from '@angular/core';
import * as FullStory from '@fullstory/browser';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { filter, map } from 'rxjs/operators';
import { AuthUser } from '../auth/core/auth-user.model';
import { SignInSuccess, SignOut } from '../auth/core/auth.actions';

@Injectable()
export class MonitoringEffects {
  constructor(actions$: Actions) {
    // Associate the current user with FullStory session on sign in success.
    actions$
      .pipe(
        ofActionDispatched(SignInSuccess),
        map(({ user }: SignInSuccess) => user),
        filter(user => !!user && !!user.id),
      )
      .subscribe(user => this.identify(user));

    // Release the identity of the current user and create a new anonymous session on sign out.
    actions$
      .pipe(ofActionDispatched(SignOut))
      .subscribe(_ => FullStory.anonymize());
  }

  private identify(user: AuthUser) {
    FullStory.identify(user.id, { displayName: user.name, email: user.email, roles: user.roles });
  }
}
